import React from 'react';
import PropTypes from 'prop-types';

export default function cleanLayout({ children }) {
  return <>{children}</>;
}

cleanLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
